/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AttributeDefinitionForBoolean extends models.AttributeDefinitionBase {
    constructor() {
        super();
        this.setDiscriminator("AttributeDefinitionForBoolean");
    }

    getFixupPrototypeFunction() { return AttributeDefinitionForBoolean.fixupPrototype; }

    static newInstance(model: Partial<AttributeDefinitionForBoolean>): AttributeDefinitionForBoolean {
        let obj = Object.assign(new AttributeDefinitionForBoolean(), model);
        AttributeDefinitionForBoolean.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AttributeDefinitionForBoolean>): AttributeDefinitionForBoolean {
        if (!model) return null;
        return AttributeDefinitionForBoolean.newInstance(<AttributeDefinitionForBoolean> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AttributeDefinitionForBoolean) {
        if (!obj) return;

        models.AttributeDefinitionForBoolean.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AttributeDefinitionForBoolean): boolean {
        if (models.AttributeDefinitionBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, AttributeDefinitionForBoolean.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
